import { render, staticRenderFns } from "./CsvDownloader.vue?vue&type=template&id=582faa1c&scoped=true&"
import script from "./CsvDownloader.vue?vue&type=script&lang=ts&"
export * from "./CsvDownloader.vue?vue&type=script&lang=ts&"
import style0 from "./CsvDownloader.vue?vue&type=style&index=0&id=582faa1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582faa1c",
  null
  
)

export default component.exports